/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon24Regular = forwardRef('ArrowRoundSyncForwardIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M11.276 3.782a8.25 8.25 0 0 1 8.072 4.468H15.5a.75.75 0 0 0 0 1.5H21a.75.75 0 0 0 .75-.75V3.246a.75.75 0 0 0-1.5 0v3.558a9.75 9.75 0 0 0-17.821 3.338.75.75 0 0 0 1.472.286 8.25 8.25 0 0 1 7.375-6.646Z" }),
        React.createElement("path", { d: "M7.625 18.994a8.25 8.25 0 0 0 12.466-5.383.75.75 0 1 1 1.471.293A9.75 9.75 0 0 1 3.75 17.196v3.558a.75.75 0 0 1-1.5 0V15a.75.75 0 0 1 .75-.75h5.5a.75.75 0 0 1 0 1.5H4.652a8.25 8.25 0 0 0 2.973 3.244Z" })));
});
